module.exports = __webpack_public_path__ + "img/park-live-second-block-img.da5082fa.png";